var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.dialog,
        persistent: "",
        "max-width": "720px",
        fullscreen: _vm.$vuetify.breakpoint.xsOnly,
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.item ? "Editar novedad" : "Nueva novedad")),
                ]),
              ]),
              _c(
                "v-card-text",
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12 pb-0" },
                      [
                        _c("BaseInput", {
                          attrs: {
                            label: "Título*",
                            name: "title",
                            rules: "required|max:255",
                            validationErrors: _vm.errors,
                          },
                          model: {
                            value: _vm.form.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "title", $$v)
                            },
                            expression: "form.title",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12 py-0" }, [
                      _c(
                        "div",
                        { staticClass: "text-left mb-3" },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center mb-2" },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-2 icon-chevron",
                                attrs: { icon: "chevron-right" },
                              }),
                              _c("v-label", { staticClass: "label-input" }, [
                                _vm._v("Mensaje"),
                              ]),
                            ],
                            1
                          ),
                          _c("v-textarea", {
                            attrs: {
                              name: "body",
                              rows: "3",
                              outlined: "",
                              dense: "",
                            },
                            model: {
                              value: _vm.form.body,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "body", $$v)
                              },
                              expression: "form.body",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-7 py-0" },
                      [
                        _c("BaseInput", {
                          attrs: {
                            label: "Link o video de YouTube",
                            name: "link_url",
                            rules: _vm.link_rules,
                            validationErrors: _vm.errors,
                          },
                          model: {
                            value: _vm.form.link_url,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "link_url", $$v)
                            },
                            expression: "form.link_url",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-5 py-0" },
                      [
                        _c("BaseInput", {
                          attrs: {
                            label: "Texto del link",
                            name: "link_text",
                            rules: "max:255",
                            validationErrors: _vm.errors,
                          },
                          model: {
                            value: _vm.form.link_text,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "link_text", $$v)
                            },
                            expression: "form.link_text",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "news-modal__files" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center mb-2" },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "mr-2 icon-chevron",
                          attrs: { icon: "chevron-right" },
                        }),
                        _c("v-label", { staticClass: "label-input" }, [
                          _vm._v("Archivos"),
                        ]),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "container-documents" }, [
                      _c(
                        "div",
                        {
                          staticClass: "drop-area news-modal__drop",
                          attrs: { role: "button", tabindex: "0" },
                          on: {
                            click: function ($event) {
                              return _vm.$refs.file_input.click()
                            },
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              $event.preventDefault()
                              return _vm.$refs.file_input.click()
                            },
                            dragover: function ($event) {
                              $event.preventDefault()
                            },
                            dragenter: function ($event) {
                              $event.preventDefault()
                            },
                            drop: function ($event) {
                              $event.preventDefault()
                              _vm.addFiles(
                                Array.from($event.dataTransfer.files)
                              )
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "download-icon",
                            attrs: { icon: "fa-download" },
                          }),
                          _c("p", { staticClass: "mt-3 mb-0" }, [
                            _vm._v(
                              "Suelta los archivos aquí o haz clic para seleccionarlos"
                            ),
                          ]),
                          _c("input", {
                            ref: "file_input",
                            attrs: {
                              type: "file",
                              hidden: "",
                              multiple: "",
                              accept: _vm.accept,
                            },
                            on: { change: _vm.onPickFiles },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "news-modal__hint" }, [
                      _vm._v(
                        "PDF, imágenes o videos. Hasta " +
                          _vm._s(_vm.max_files) +
                          " archivos y 38 MB por guardado."
                      ),
                    ]),
                    _vm.files_error
                      ? _c("span", { staticClass: "red--text" }, [
                          _vm._v(_vm._s(_vm.files_error)),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._l(_vm.current_attachments, function (attachment) {
                    return _c(
                      "div",
                      {
                        key: "current-" + attachment.id,
                        staticClass: "news-modal__file",
                      },
                      [
                        _c("span", { staticClass: "news-modal__file-name" }, [
                          _vm._v(_vm._s(attachment.name)),
                        ]),
                        _c("span", { staticClass: "news-modal__file-size" }, [
                          _vm._v(_vm._s(_vm.formatSize(attachment.size))),
                        ]),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              small: "",
                              "aria-label": "Quitar archivo",
                              title: "Quitar archivo",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.removeCurrent(attachment)
                              },
                            },
                          },
                          [
                            _c(
                              "v-icon",
                              { attrs: { small: "", color: "red" } },
                              [_vm._v("mdi-close")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _vm._l(_vm.new_files, function (entry, index) {
                    return _c(
                      "div",
                      { key: entry.key, staticClass: "news-modal__file" },
                      [
                        _c("span", { staticClass: "news-modal__file-name" }, [
                          _vm._v(_vm._s(entry.file.name)),
                        ]),
                        _c("span", { staticClass: "news-modal__file-size" }, [
                          _vm._v(_vm._s(_vm.formatSize(entry.file.size))),
                        ]),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              small: "",
                              "aria-label": "Quitar archivo",
                              title: "Quitar archivo",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.removeNew(index)
                              },
                            },
                          },
                          [
                            _c(
                              "v-icon",
                              { attrs: { small: "", color: "red" } },
                              [_vm._v("mdi-close")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c("v-checkbox", {
                    attrs: { label: "Fijar arriba del muro" },
                    model: {
                      value: _vm.form.pinned,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "pinned", $$v)
                      },
                      expression: "form.pinned",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-card-actions",
                { staticClass: "news-modal__actions" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error", text: "", disabled: _vm.saving },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [_vm._v("Cerrar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", disabled: _vm.saving },
                      on: {
                        click: function ($event) {
                          return _vm.save(false)
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.is_published
                            ? "Pasar a borrador"
                            : "Guardar borrador"
                        )
                      ),
                    ]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        text: "",
                        loading: _vm.saving,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.save(true)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.is_published ? "Guardar" : "Publicar"))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }